import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmRackDropDownDto } from './rm-rack-drop-down.dto';


export class RmRackDropDownResponseModel extends GlobalResponseObject {
    data?: RmRackDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RmRackDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

